import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']
const lightColor = (props) => props.theme.global.colors['white']

export const Container  = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${lightColor};
  flex: 1;
`

export const BrandText = styled.p`
  color: ${darkColor};
  font-size: 16px;
  font-weight: 600;
  line-height: 26.4px;
  text-align: left;
  margin: 0 0 16px;

  span {
    color: ${darkColor};
    font-size: 16px;
    font-weight: 600;
    line-height: 26.4px;
    text-transform: uppercase;

    @media screen and (max-width: 992px) {
      font-size: 14px;
    }
  }

  span:last-child {
    font-weight: 400;
    text-transform: none;
  }

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
`